import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { ROLES } from "../constants/roles";
import {
  CashCollectionPage,
  HomePage,
  PageNotFoundPage,
  BatteryMovementPage,
  ManualSwapPage,
  EmiCalculatorPage,
  OnboardingPage,
  PreOnboardingUpdatePage,
  DriverLeadCreationPageV2,
} from "../pages";
import paths from "./paths";
import DriverLeadCreationPage from "../pages/DriverLeadCreationPage";
import LeadDocumentUploadPage from "../pages/LeadDocumentUploadPage";
import OnboardingProtectedRoute from "./OnboardingAccessRoute";
import LeadProtectedRoute from "./LeadProtectedRoute";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={paths.HOME} element={<HomePage />} />

      <Route
        path={paths.CASH_COLLECTION}
        element={
          <ProtectedRoute role={ROLES.CASH_COLLECTION}>
            <CashCollectionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={paths.MANUAL_SWAP}
        element={
          <ProtectedRoute role={ROLES.MANUAL_SWAP}>
            <ManualSwapPage />
          </ProtectedRoute>
        }
      />

      <Route
        path={paths.BATTERY_MOVEMENT}
        element={
          <ProtectedRoute role={ROLES.BATTERY_MOVEMENT}>
            <BatteryMovementPage />
          </ProtectedRoute>
        }
      />

      <Route
        path={paths.EMI_CALCULATOR}
        element={
          <ProtectedRoute role={ROLES.EMI_CALCULATOR}>
            <EmiCalculatorPage />
          </ProtectedRoute>
        }
      />

      <Route
        path={paths.DRIVER_LEAD_CREATION_V1}
        element={
          <LeadProtectedRoute>
            <DriverLeadCreationPage />
          </LeadProtectedRoute>
        }
      />

      <Route
        path={paths.DRIVER_LEAD_CREATION}
        element={
          <LeadProtectedRoute>
            <DriverLeadCreationPageV2 />
          </LeadProtectedRoute>
        }
      />

      <Route
        path={paths.LEAD_DOCUMENTATION}
        element={
          <ProtectedRoute role={ROLES.ONBOARDING}>
            <LeadDocumentUploadPage />
          </ProtectedRoute>
        }
      />

      <Route
        path={paths.DRIVER_ONBOARDING}
        element={
          <OnboardingProtectedRoute>
            <OnboardingPage />
          </OnboardingProtectedRoute>
        }
      />

      <Route
        path={paths.PRE_ONBOARDING_UPDATE}
        element={
          <ProtectedRoute role={ROLES.ONBOARDING}>
            <PreOnboardingUpdatePage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<PageNotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
